import { Autocomplete, Chip, Grid, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CHANNEL_OPTIONS, selectChannels } from 'pages/PosSettings/channels';

/**
 * Picks where the promotion applies. Must be rendered inside a Grid container
 * and a FormProvider.
 */
const ChannelSelect = ({ xs = 6 }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <Grid item xs={xs}>
      <Controller
        name="channels"
        control={control}
        render={({ field }) => {
          const selected = CHANNEL_OPTIONS.filter((option) =>
            (field.value || []).includes(option.value)
          );
          return (
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={CHANNEL_OPTIONS}
              getOptionLabel={(option) => t(option.label)}
              value={selected}
              onChange={(_, newValue) =>
                field.onChange(
                  selectChannels(
                    field.value || [],
                    newValue.map((option) => option.value)
                  )
                )
              }
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  label={t('Channels')}
                  InputLabelProps={{ shrink: true }}
                />
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    label={t(option.label)}
                    size="small"
                    {...getTagProps({ index })}
                    key={option.value}
                  />
                ))
              }
            />
          );
        }}
      />
    </Grid>
  );
};

export default ChannelSelect;
